// extracted by mini-css-extract-plugin
export default {"navBar":"navBar__1C8jE","plantTabs":"plantTabs__1YSow","mobile-menu":"mobile-menu__2TT-J","stickyNavBar":"stickyNavBar__2ZN3n"};